import type { SampleExamApiQuestion } from '../../../services/sampleExamTypes';

/** Backend supports only SINGLE (incl. objective) and MATCH_PAIR; everything else is treated as single in the UI. */
export type UiQuestionType = 'single' | 'match_pair';

export function examQuestionUiType(q: SampleExamApiQuestion): UiQuestionType {
  const t = (q.questionType ?? '').toUpperCase();
  if (t === 'MATCH_PAIR') return 'match_pair';
  return 'single';
}

function resolveOptionValue(opts: SampleExamApiQuestion['options'], token: string): string | null {
  const t = token.trim();
  if (t === '') return null;
  const list = opts ?? [];
  const byText = list.find((o) => String(o.optionText).trim() === t);
  if (byText) return String(byText.optionId);
  const byId = list.find((o) => String(o.optionId) === t);
  if (byId) return String(byId.optionId);
  return null;
}

/**
 * Map API `studentAnswer` into the same shape the UI uses (option id strings for SINGLE; object for MATCH_PAIR).
 */
export function initialAnswerFromStudentField(q: SampleExamApiQuestion): unknown {
  const raw = q.studentAnswer;
  if (raw == null || String(raw).trim() === '') return undefined;

  const ui = examQuestionUiType(q);
  const s = String(raw).trim();

  if (ui === 'match_pair') {
    try {
      const parsed = JSON.parse(s) as unknown;
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) return parsed;
    } catch {
      /* ignore */
    }
    return undefined;
  }

  const v = resolveOptionValue(q.options, s);
  return v ?? s;
}
